import React, { useEffect, useState, Fragment } from 'react';
import { Pagination, PageHeader, paginate } from '../../../Common';
import { TableContent } from '../../Common/Table/tableContent';
import services from '../services';
import { search, SearchFeild } from '../../Common';
import $ from 'jquery';
import authService from '../../Common/services';
import { trackPromise } from 'react-promise-tracker';
import { LoadingSpinerComponent } from '../../../Common/loader'

const screenCode = 'COLLECTIONTYPE';

export function CollectionTypeListing(props){

    const [collectiontype, setCollectionType] = useState([]);
    
    const contentRowNames = ["collectionTypeCode", "collectionTypeName", "isActive"]

    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false
    });


    useEffect(() => {
        trackPromise(
            getPermissions()
        )
    }, []);

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWCOLLECTIONTYPELISTING');

        if(isAuthorized === undefined){
            props.history.push('/unauthorized');
        }

        var isAddEditEnabled = permissions.find(p => p.permissionCode == 'ADDEDITCOLLECTIONTYPE');

        if(isAddEditEnabled != undefined){
            setPermissions({
                ...permissionList,
                isAddEditEnabled: true
            });
        }

        getAllCollectionType();
    }

    function destroyDataTable(){
        $('#example').DataTable().destroy();
    }

    function createDataTable(){
        $('#example').DataTable();
    }

    async function getAllCollectionType(){
        var data
        data = await services.getAll()
        destroyDataTable()
        setCollectionType(data)
        createDataTable()
    }

    function handleClick(collectiontype) {
        props.history.push({
            pathname: 'collectiontype/addEdit',
            data: collectiontype,
            edit: true
        })
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
        <div className="row">
            <div className="col-md-12">
                    <div className="card">
                        <PageHeader
                            title="CollectionType"
                            isButtonEnable={permissionList.isAddEditEnabled}
                            buttonText="Add CollectionType"
                            path="collectiontype/addEdit" />
                    <div className="card-body">
                      
                          
                       
                        <div className="table-responsive row-top-gap">
                            <table id="example" className="display dataTable no-footer">
                                <thead>
                                    <tr>
                                            <th>Collection Type Code</th>
                                            <th>Collection Type Name</th>
                                            <th>Status</th>
                                            { permissionList.isAddEditEnabled ? <th>Actions</th> : null }
                                    </tr>
                                </thead>
                                <tbody>
                                        <TableContent
                                            data={collectiontype}
                                            contentRowNames={contentRowNames}
                                            hasEdit={permissionList.isAddEditEnabled}
                                            handleClick={handleClick}
                                   
                                    />
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Fragment>
    )
}


